export const selectable = () => ({
	selectable: {
		selectable: true,
	},
	'not-selectable': {
		selectable: false,
	},
});
